'use client';
import { useState, useCallback } from 'react';
import { ChallengeContext } from '../contexts/challenge-context'
import { getChallenge } from 'app/lib/data/challenge';

export function ChallengeProvider({ children, challenge: initialActivity, error }) {
  const [challenge, setChallenge] = useState(initialActivity);
  
  const mutate = useCallback(async () => {
    if (!challenge) return null;
    if (!challenge.id) return null;
    const updated = await getChallenge(challenge.id)
    setChallenge(updated);
  }, [challenge])

  return (
    <ChallengeContext.Provider value={{ challenge, error, mutate }}>
      {children}
    </ChallengeContext.Provider>
  )
}